import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Breadcrumb,
  BreadcrumbItem
} from "reactstrap";
import { Link } from "react-router-dom";
import {
  ClockCircleOutlined,
  EyeOutlined,
  CalendarOutlined,
  UserOutlined,
  HomeOutlined
} from "@ant-design/icons";
import { format } from "date-fns";
import axios from "axios";
import "../../styles/blogs.css";

const BlogDisplay = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = "https://techcrew.pk/ulc/";

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}Get_Blogs.php`);
        if (data.status && data.status.code === 200) {
          setBlogs(data.data);
        } else {
          console.error("Failed to fetch blogs");
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (loading) {
    return (
      <section className="blog-display-section py-5">
        <Container>
          <div className="text-center py-5">
            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
            <p className="mt-3">Loading blog content...</p>
          </div>
        </Container>
      </section>
    );
  }

  return (
    <div className="blog-page">
      {/* Header Section */}
      <section className="blog-header py-5">
        <Container>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/">
                <HomeOutlined /> Home
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/blogs">Blogs</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>{blogs[0]?.title || "Blog"}</BreadcrumbItem>
          </Breadcrumb>
          
          <Row className="justify-content-center">
            <Col lg="10" className="text-center">
              <h6 className="blog-category">CONSTRUCTION EQUIPMENT</h6>
              <p className="blog-main-title">{blogs[0]?.title}</p>
              <p className="blog-main-subtitle">{blogs[0]?.subtitle}</p>
              
              <div className="blog-meta-main">
                <span className="blog-date">
                  <CalendarOutlined /> 
                  {format(new Date(blogs[0]?.created_at), 'MMMM dd, yyyy')}
                </span>
                <span className="blog-author">
                  <UserOutlined /> Admin
                </span>
                <span className="blog-read-time">
                  <ClockCircleOutlined /> {Math.floor(Math.random() * 5) + 5} min read
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Image */}
      {blogs[0]?.featured_image && (
        <section className="blog-featured-image">
          <Container>
            <Row className="justify-content-center">
              <Col lg="8" md="12">
                <div className="featured-image-container">
                  <img
                    src={`https://techcrew.pk/ulc/${blogs[0]?.featured_image}`}
                    alt={blogs[0]?.title}
                    className="featured-img"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      {/* Blog Content Sections */}
      <section className="blog-content-sections py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg="7" md="10">
              {blogs[0]?.sections?.map((section, index) => (
                <div key={index} className={`section-wrapper ${section.content_type}`}>
                  {section.content_type === "text" ? (
                    <div className="text-section">
                      <p className="section-text">{section.content}</p>
                    </div>
                  ) : (
                    <div className="image-section">
                      <div className="image-container">
                        <img
                          src={`https://techcrew.pk/ulc/${section.image_path}`}
                          alt={`Blog visual ${index + 1}`}
                          className="section-image"
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))}
              
              {/* Call to Action */}
              <div className="blog-cta mt-5">
                <h3>Need Construction Equipment?</h3>
                <p>Contact us today for affordable rental solutions tailored to your project needs.</p>
                <Button color="primary" size="lg" className="cta-button">
                  Get a Quote
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default BlogDisplay;